import { Component, OnInit } from '@angular/core';
import { BzgModalService, BzgModalRef, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { EncryptionService } from '../services/column-encryption.service';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'biz-encryption-entity-logs',
  templateUrl: './encryption-entity-logs.component.html',
  styleUrls: ['./encryption-entity-logs.component.scss']
})
export class EncryptionEntityLogsComponent implements OnInit {
  public enableEntityLogs: boolean = false;
  public isLoading: boolean = false;
  constructor(
    private _modalService: BzgModalService,
    private _encryptionService: EncryptionService,
    private _toastService: BzgToastService,
    private _i18nService: I18nService,
    private _showToastService: ShowToastService
  ) {

  }

  ngOnInit(): void {
    this.getValueEnableEntityLogs();
  }

  getValueEnableEntityLogs() {
    this._encryptionService.IsEntityLogsEnabled().then((isEnabled) => {
      this.enableEntityLogs = isEnabled;
    }
    ).catch(() => {
      this.enableEntityLogs = false;
    });
  }

  onChangeEntityLogs(newValue: boolean) {
    this.isLoading = true;
    this._encryptionService.SetEntityLogsEnabled(newValue).then(() => {
      this.isLoading = false;
      this.enableEntityLogs = newValue;
      this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
    }).catch(() => {
      this.enableEntityLogs = !newValue;
      this._showToastService.showToast(this._i18nService.instant('GLOBAL.AN_ERROR_HAS_OCCURRED'), 'error');
    });
  }

}
